



import ListPublicEvents from '@/components/Templates/User/Event/List/ListPublicEvents.vue';

export default {
    name: 'EmbedEventList',
};
